const NotFound = () => {
    return (
        <div>

            <h1 className="ofo-page-not-found">404</h1>

        </div>
    )
}

export default NotFound